import {StyleSheet, View} from "react-native";
import {Color} from "@/lib/styles";
import {AggregateActivity} from "@/lib/types";
import Card from "@/lib/components/Card";
import {useQueryClient} from "@tanstack/react-query";
import AvatarBox from "@/lib/components/AvatarBox";
import Header from "@/lib/components/Header";
import Timestamp from "@/lib/components/Timestamp";
import useCrossTabNavigation from "@/lib/crosstab";
import PrimaryText from "@/lib/components/PrimaryText";

type Props = {
    activity: AggregateActivity,
}

export default function GroupActivity({activity}: Props) {
    const queryClient = useQueryClient();
    const {navigate} = useCrossTabNavigation();

    if (!activity.group) {
        return null;
    }

    function navigateTo() {
        // noinspection JSIgnoredPromiseFromCall
        queryClient.invalidateQueries();
        if (activity.group) {
            navigate(`/s/${activity.group.group_id}`);
        }
    }

    const group = activity.group;
    const avatarbox = activity.attendees.concat(activity.followers).concat(activity.solicitors);

    return (
        <Card image_url={group.image_url}
              color={group.color}
              contrast_color={group.contrast_color}
              title={group.name}
              onPress={navigateTo}
        >
            <View style={{flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: 16}}>
                <PrimaryText>Siste hendelse</PrimaryText>
                <Timestamp autoFade={false} relativeSince={true} start={new Date(activity.activity_at)}/>
            </View>
            {activity.activities.map((act, index) => (
                <View key={index}>
                    {act === "permissions" && <Header icon={"edit"} title={"Du har nytt tilgangsnivå"}/>}
                    {act === "updated" && <Header icon={"participants"} title={"Samfunnet er oppdatert med ny info"}/>}
                    {act === "invited" && <Header icon={"relation"} title={`${group.invited_by?.username || "Noen"} inviterte deg`}/>}
                </View>
            ))}
            {activity.solicitors.length > 0 && <Header icon={"relation"} title={`Noen ber om invitasjon ( ${activity.solicitors.length} )`}/>}
            {activity.attendees.length > 0 && <Header icon={"relation"} title={`${activity.attendees.length} av dine venner ble medlem`}/>}
            {activity.followers.length > 0 && <Header icon={"relation"} title={`${activity.followers.length} av dine venner følger`}/>}
            {avatarbox.length > 0 &&
                <AvatarBox icon={"participants"} border={false} avatars={activity.attendees.concat(activity.followers)} color={group.color}/>
            }
        </Card>
    )
}

export const styles = StyleSheet.create({
    container: {
        backgroundColor: Color.BackgroundContainer,
        borderRadius: 8,
        paddingHorizontal: 12,
        paddingVertical: 12,
    },
})